import { topics } from '@/mocks/home';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1200px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            当下影迷圈最热讨论话题，看看大家都在聊什么
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {topics.map((topic) => (
            <div
              key={topic.id}
              className="group flex items-center gap-3 px-4 py-3 bg-background-100 hover:bg-primary-50/70 border border-background-200 hover:border-primary-200 rounded-xl transition-all cursor-pointer"
            >
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-700 whitespace-nowrap">
                #{topic.name}
              </span>
              <div className="flex items-center gap-1.5">
                <span className="text-xs text-foreground-400">
                  {topic.count.toLocaleString()}
                </span>
                <i className="ri-arrow-up-line text-xs text-accent-500"></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}